/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-07-15 17:58:33
 * @LastEditors: linwc
 * @LastEditTime: 2025-12-02 09:34:41
 */
import { getProjectImages } from '@/apps';

const _imgStore = {
  ...require('./imgs/commonImgStore'),
  ...getProjectImages()
};

export function getImage(flag, hasBase = true) {
  if (!_imgStore[flag]) {
    console.error('not found image:', flag);
    return hasBase ? '' : false;
  } else {
    let imgFlag = _imgStore[flag];
    const isNoQuality = imgFlag.indexOf('imageMogr2/quality') === -1;
    const isPng = imgFlag.indexOf('.png') !== -1;
    const isJpg = imgFlag.indexOf('.jpg') !== -1 || imgFlag.indexOf('.jpep') !== -1;
    if (isNoQuality && (isPng || isJpg)) {
      imgFlag = `${imgFlag}`;
    }
    return imgFlag;
  }
}
